<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Sponsor Destacado:</h3>
          </v-col>

          <v-col cols="12">
            <v-text-field
              ref="edition.name"
              v-model="name"
              outlined
              :maxlength="100"
              :counter="100"
              :rules="[v => (v || '' ).length <= 99 || 'El nombre no debe tener mas de 100 caracteres']"
              label="Nombre"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              ref="web"
              v-model="web"
              outlined
              :maxlength="100"
              :counter="100"
              :rules="[v => (v || '' ).length <= 99 || 'La URL no debe tener mas de 100 caracteres']"
              label="Web"
              required
            ></v-text-field>
          </v-col>

        </v-row>
      </v-sheet>
      
      <v-sheet
        class="mt-4"
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">
          <v-col cols="12">
            <h3 class="font-weight-regular">Logo:</h3>
          </v-col>
          
          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!logo"
              v-model="logo"
              :rules="rules"
              @change="onLogoChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Logo"
              :messages="['Para una mejor visualización, usar un logo cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              max-width="380px"
              v-if="logo"
              wei>
              <v-img
                contain
                :src="url_logo"
                class="grey lighten-2"
                height="240px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteLogo()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'featuredSponsorsEdition', params: { edition_id:this.edition_id, types_feature_sponsor_id: this.types_feature_sponsor_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_btn"
        :disabled="!logo"
        color="primary"
        @click="saveSponsor()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'newSponsorsEdition',

    data: () => ({
      loading_btn: false,
      loading_update:false,

      name:null,
      web:null,

      logo:null,
      url_logo:null,
      rules: [
        (value) =>
          !value ||
          value.size < 2 ||
          "El archivo es demaciado grande",
      ],

      edition_id: null,
      types_feature_sponsor_id: null,
    }),

    methods:{
      async saveSponsor()
      {
        this.loading_btn = true

        let formData= new FormData()
        formData.append('name', this.name)
        
        if(this.web!=null){
          formData.append('web', this.web);
        }
        
        formData.append('logo', this.logo)

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/types-featured-sponsors/'+this.types_feature_sponsor_id+'/featured-sponsors',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.dialog_new = false
            this.loading_btn = false
            this.loading = true
            this.$router.push({ name: 'featuredSponsorsEdition', params: { edition_id: this.edition_id, types_feature_sponsor_id: this.types_feature_sponsor_id } })
          })
        } catch (error) {
          this.dialog_new_edition = false
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      onLogoChange() {
        this.url_logo = URL.createObjectURL(this.logo);
      },

      deleteLogo(){
        this.logo=null
        this.url_logo=null
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.types_feature_sponsor_id = this.$route.params.types_feature_sponsor_id
    },
  }
</script>
